import React, { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import { useError } from 'contexts/error';
import { SecretTypography } from 'components/styles_components/typography';
import VerificationForm from 'components/user/two_factor/verification_form';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import EnableMutation from 'mutations/user/two_factor/enable';

const ModalEnable2fa = ({ qrCode, secret, onSuccess }) => {
  const setError = useError();
  const intl = useIntl();
  const [secretVisible, setSecretVisible] = useState(false);
  const [copied, setCopied] = useState(false);
  const [enableMutation, { loading }] = useMutation(EnableMutation, {
    onCompleted: onSuccess,
    onError: () => {
      setError('error.user.two_factor.enable');
    },
  });

  const secretCode = () => {
    if (secretVisible) {
      return (
        <>
          <SecretTypography>{secret}</SecretTypography>
          <CopyToClipboard text={secret} onCopy={() => setCopied(true)}>
            <Button>
              {copied ? (
                <FormattedMessage id="button.copied" />
              ) : (
                <FormattedMessage id="button.copy" />
              )}
            </Button>
          </CopyToClipboard>
        </>
      );
    }
  };

  const secretCodeButton = () => {
    return (
      <Button className="margin-top-10" onClick={() => setSecretVisible(!secretVisible)}>
        <FormattedMessage
          id={secretVisible ? 'button.verification.code.hide' : 'button.verification.code.show'}
        />
      </Button>
    );
  };

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.user.two_factor.disable" />
      </ModalTypography>
      <img src={`data:image/png;base64,${qrCode}`} />
      {secretCodeButton()}
      {secretCode()}
      <VerificationForm
        initialValues={{
          code: '',
        }}
        submitLabel={<FormattedMessage id="button.two_factor.enable" />}
        onSubmit={(values, { setFieldError }) => {
          enableMutation({ variables: { code: values.code.toString() } }).catch(() => {
            setFieldError('code', intl.formatMessage({ id: 'error.user.two_factor.enable' }));
          });
        }}
        processing={loading}
      />
    </>
  );
};

export default ModalEnable2fa;
